import api from "../lib/apiClient";
export const verifyTraderId = () => api.post("/trader/verify").then((r) => r.data);
export const getTraderStatus = () => api.get("/trader/status").then((r) => r.data);
// Placeholder for affiliate registration source lookup (backend-ready).
export const getAffiliateRegistration = () => api.get("/auth/me").then((r) => ({ affiliate_source: r.data.affiliate_source }));
